import { MenuItemType } from '@/app/types/layout';

export const menuItems: MenuItemType[] = [
  { label: 'Insights', labelKey: 'insightsTitle', isTitle: true },
  {
    icon: '/assets/icons/sprite.svg#home',
    label: 'Home',
    labelKey: 'home',
    url: '/home',
  },
  {
    icon: '/assets/icons/sprite.svg#icon-mode-map',
    label: 'Maps',
    labelKey: 'maps',
    url: '/mindmap',
  },
  {
    icon: '/assets/icons/sprite.svg#book-open',
    label: 'Deck',
    labelKey: 'deck',
    url: '/deck',
  },
  {
    icon: '/assets/icons/sprite.svg#trash-2',
    label: 'Trash',
    labelKey: 'trash',
    url: '/trash',
  },
  {
    icon: '/assets/icons/sprite.svg#settings',
    label: 'Settings',
    labelKey: 'settings',
    url: '/settings',
  },
  {
    icon: '/assets/icons/sprite.svg#arrow-up-right',
    label: 'Upgrade',
    labelKey: 'upgrade',
    action: 'upgrade',
  }
];
